import React from 'react';
import FetchOptionsSelect from "./FetshOptionsSelect";
import {useTranslation} from "react-i18next";
import {GetPackageCodes} from "../../api";

const PackageCodeSelect = ({ onChange,defaultOfficeIds = [], ...props }) => {

    const { t } = useTranslation();

    const formatOfficeOptions = (response) => {
        return response.data.map(fetchOption => ({
            value: fetchOption.code,
            label: fetchOption.description
        }))
    }
    return <FetchOptionsSelect
        onChange={onChange}
        fetchOptionsFunction={GetPackageCodes}
        fetchOptionsFilterParams={{ limit: 50, offset: 0 , program_id: props.programId}}
        loadingPlaceholder={t("Loading Package Codes...")}
        placeholderText={t("Select code")}
        defaultFetchOptionIds={defaultOfficeIds}
        formatFetchOptionsFunction={formatOfficeOptions}
        {...props}
    />
};

export default PackageCodeSelect;
